import { IsAppInfo } from '../interfaces/is-app-info';
import packageJson from '../../../../package.json';
import { BASE64_SLICE_SIZE } from 'src/constants/request-queue';

export const getAppInfo = (): IsAppInfo => {
  const appInfo: IsAppInfo = {
    name: packageJson.name,
    version: packageJson.version,
    author: packageJson.author,
    homepage: packageJson.homepage,
    privacyPage: packageJson.privacyPage
  };
  return appInfo;
};

export const wait = (ms: number): Promise<void> =>
  new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });

export const isObject = (obj: any): boolean => obj !== null && typeof obj === 'object';

/**
 * Converts a base64 string to a Blob.
 * The string is decoded in slices so a multi megabyte photo does not have to be
 * held in memory as one large intermediate array.
 * @param base64 The base64 string without a data url prefix
 * @param mimeType The content type the resulting Blob should report
 */
export const base64ToBlob = (base64: string, mimeType: string = ''): Blob => {
  const byteCharacters: string = atob(base64);
  const byteArrays: BlobPart[] = [];

  for (let offset = 0; offset < byteCharacters.length; offset += BASE64_SLICE_SIZE) {
    const slice: string = byteCharacters.slice(offset, offset + BASE64_SLICE_SIZE);
    const byteNumbers: number[] = new Array(slice.length);
    for (let index = 0; index < slice.length; index++) {
      byteNumbers[index] = slice.charCodeAt(index);
    }
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: mimeType });
};
